import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getCoursesCategories, getCoursesLevels, getCoursesTypes, getCourses} from '../../actions';
import {withRouter} from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import Drawer from '@material-ui/core/Drawer';
import Button from "@material-ui/core/Button/Button";
import CloseIcon from '@material-ui/icons/Close';
import IconFilter from '../../assets/img/icon-filter.svg';
import {withLastLocation} from 'react-router-last-location';

class CoursesSearch extends Component {
    state = {
        checkedEnglish: false,
        checkedSuggestions: false,
        checkedTypes: false,
        category: '',
        level: '',
        type: '',
        userClick: false,
        populateFromSearch: false,
        mobileFilterDrawerOpen: false,
        hasCameFromOtherPage: false,
    };

    componentDidMount() {
        this.props.getCoursesCategories();
        this.props.getCoursesLevels();
        this.props.getCoursesTypes();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.category !== prevState.category || this.state.level !== prevState.level || this.state.type !== prevState.type || this.state.checkedEnglish !== prevState.checkedEnglish || this.state.checkedSuggestions !== prevState.checkedSuggestions) {
            if (this.state.userClick) {
                // Only trigger a search when the user itself change the search criteria...
                // It's important to reset the 'userClick' to false before.
                this.setState({
                    userClick: false,
                }, () => this.props.getCourses(
                    1, // No offset
                    true, // Reset the search results / listing
                    this.state.category,
                    this.state.level,
                    this.state.type,
                    this.state.checkedEnglish,
                    this.state.checkedSuggestions,
                ));
            }
        }

        // Auto populate the dropdowns and checkboxes if the user comes from another page
        // (home page with the search bar, or course details page)
        // -------------------------------------------------------

        const {lastLocation} = this.props;
        const {categories, levels, types, search} = this.props.courses;

        if (this.state.hasCameFromOtherPage === false && typeof lastLocation === 'object' && lastLocation !== null && lastLocation.hasOwnProperty('pathname') && lastLocation.pathname.length > 0) {
            let searchCategory = '';
            let searchLevel = '';
            let searchType = '';
            let searchEnglish = false;
            let searchSuggestions = false;

            if (categories.length > 0) {
                // The categories has been fetched.
                // We can now check if the user has search by categories and update the active dropdown item.
                if (search.category !== '' && search.category !== prevState.category && prevState.populateFromSearch === false) {
                    //searchCategory = parseInt(search.category, 10);
                    searchCategory = search.category;
                }
            }

            if (levels.length > 0) {
                // The levels has been fetched.
                // We can now check if the user has search by level and update the active dropdown item.
                if (search.level !== '' && search.level !== prevState.level && prevState.populateFromSearch === false) {
                    //searchLevel = parseInt(search.level, 10);
                    searchLevel = search.level;
                }
            }

            if (types.length > 0) {
                // The types has been fetched.
                // We can now check if the user has search by type and update the active dropdown item.
                if (search.type !== '' && search.type !== prevState.type && prevState.populateFromSearch === false) {
                    //searchType = parseInt(search.type, 10);
                    searchType = search.type;
                    // 'checkedTypes': true,
                }
            }

            if (search.english === true && search.english !== prevState.checkedEnglish && prevState.populateFromSearch === false) {
                searchEnglish = search.english;
            }

            if (search.suggestions === true && search.suggestions !== prevState.checkedSuggestions && prevState.populateFromSearch === false) {
                searchSuggestions = search.suggestions;
            }

            let updatedState = {
                hasCameFromOtherPage: true,
                populateFromSearch: true,
            };

            if (searchCategory !== '') {
                updatedState.category = parseInt(searchCategory, 10);
            }

            if (searchLevel !== '') {
                updatedState.level = parseInt(searchLevel, 10);
            }

            if (searchType !== '') {
                updatedState.type = parseInt(searchType, 10);
                updatedState.checkedTypes = true;
            }

            if (searchEnglish) {
                updatedState.checkedEnglish = true;
            }

            if (searchSuggestions) {
                updatedState.checkedSuggestions = true;
            }

            this.setState(updatedState);
        }
    }

    toggleFilterDrawer = (open) => () => {
        this.setState({
            mobileFilterDrawerOpen: open,
        });
    };

    handleChange = e => {
        // NB: setState is asynchronous!
        // If we call the getCourses function here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        this.setState({
            [e.target.name]: e.target.value,
            'userClick' : true,
        });
    };

    handleChangeCheckbox = e => {
        // NB: setState is asynchronous!
        // If we call the getCourses function here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        let name = e.target.name;
        let value = e.target.checked;
        let idType = '';

        if (name === 'checkedTypes') {
            if (value) {
                idType = (e.target.value).replace('type-', '');
            }
        }

        this.setState({
            [name]: value,
            'type': idType,
            'userClick' : true,
        });
    };

    render() {
        const {categories, levels, types, taxonomiesLoading} = this.props.courses;

        let menuItemsTypes = [];
        let menuItemsProgrammes = [];
        let idTermConference = 0;

        if (categories !== null && !taxonomiesLoading) {
            categories.map(term => (
                menuItemsTypes.push(<MenuItem value={term.term_id} key={term.term_id}>{term.name}</MenuItem>)
            ));
        }

        if (levels !== null && !taxonomiesLoading) {
            levels.map(term => (
                menuItemsProgrammes.push(<MenuItem value={term.term_id} key={term.term_id}>{term.name}</MenuItem>)
            ));
        }

        if (types !== null && !taxonomiesLoading) {
            types.forEach((term, index) => {
                if (term.slug === 'conference') {
                    idTermConference = term.term_id;
                }
            });
        }

        return (
            <Fragment>
                <section id="courses-search">
                    <div className="row row-title">
                        <div className="col col-md-12 col-sm-8">
                            <h1><span>Trouvez</span> une formation</h1>
                        </div>

                        <div className="col col-5 d-md-none">
                            <Button size="medium" className="btn-filter m-auto d-flex d-lg-none justify-content-center" variant="contained" color="primary" onClick={this.toggleFilterDrawer(true)}>
                                <object data={IconFilter} type="image/svg+xml">
                                    <i className="material-icons">filter</i>
                                </object>
                                Filtrer
                            </Button>
                        </div>
                    </div>
                    <form autoComplete="off" className="d-none d-sm-none d-md-block">
                        <div className="row row-search">
                            <div className="col col-lg-3 col-md-5">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="courses-category">Domaine</InputLabel>
                                    <Select
                                        value={this.state.category}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'category',
                                            id: 'courses-category',
                                        }}
                                    >
                                        <MenuItem value={0}>
                                            <em>Tous</em>
                                        </MenuItem>
                                        {menuItemsTypes}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col col-lg-3 col-md-5">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="courses-level">Niveau</InputLabel>
                                    <Select
                                        value={this.state.level}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'level',
                                            id: 'courses-level',
                                        }}
                                    >
                                        <MenuItem value={0}>
                                            <em>Tous niveaux</em>
                                        </MenuItem>
                                        {menuItemsProgrammes}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col col-checkbox col-lg-6 col-md-12">
                                <div className="inner text-right">
                                    <label htmlFor="checkedEnglish" className="checkbox-label">
                                        <Checkbox
                                            id="checkedEnglish"
                                            name="checkedEnglish"
                                            value="checkedEnglish"
                                            checked={this.state.checkedEnglish}
                                            onChange={this.handleChangeCheckbox}
                                        />
                                        <span className="title">En anglais</span>
                                    </label>
                                    <label htmlFor="checkedSuggestions" className="checkbox-label">
                                        <Checkbox
                                            id="checkedSuggestions"
                                            name="checkedSuggestions"
                                            value="checkedSuggestions"
                                            checked={this.state.checkedSuggestions}
                                            onChange={this.handleChangeCheckbox}
                                        />
                                        <span className="title">Suggestions</span>
                                    </label>
                                    <label htmlFor="checkedTypes" className="checkbox-label">
                                        <Checkbox
                                            id="checkedTypes"
                                            name="checkedTypes"
                                            value={'type-' + idTermConference}
                                            checked={this.state.checkedTypes}
                                            onChange={this.handleChangeCheckbox}
                                        />
                                        <span className="title">Conférences</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>

                <Drawer id="filter-drawer" anchor="right" open={this.state.mobileFilterDrawerOpen} onClose={this.toggleFilterDrawer(false)} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section">Trouvez une formation</span>
                                <h2 className="title">Filtrer</h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleFilterDrawer(false)}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <form autoComplete="off">
                                <div className="row row-search">
                                    <div className="col col-12">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="courses-category">Domaine</InputLabel>
                                            <Select
                                                value={this.state.category}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'category',
                                                    id: 'courses-category',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Tous</em>
                                                </MenuItem>
                                                {menuItemsTypes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="courses-level">Niveau</InputLabel>
                                            <Select
                                                value={this.state.level}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'level',
                                                    id: 'courses-level',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Tous niveaux</em>
                                                </MenuItem>
                                                {menuItemsProgrammes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-checkbox col-12">
                                        <div className="row">
                                            <label htmlFor="checkedEnglish" className="checkbox-label col col-12">
                                                <Checkbox
                                                    id="checkedEnglish"
                                                    name="checkedEnglish"
                                                    value="checkedEnglish"
                                                    checked={this.state.checkedEnglish}
                                                    onChange={this.handleChangeCheckbox}
                                                />
                                                <span className="title">En anglais</span>
                                            </label>
                                            <label htmlFor="checkedSuggestions" className="checkbox-label col col-12">
                                                <Checkbox
                                                    id="checkedSuggestions"
                                                    name="checkedSuggestions"
                                                    value="checkedSuggestions"
                                                    checked={this.state.checkedSuggestions}
                                                    onChange={this.handleChangeCheckbox}
                                                />
                                                <span className="title">Suggestions</span>
                                            </label>
                                            <label htmlFor="checkedTypes" className="checkbox-label col col-12">
                                                <Checkbox
                                                    id="checkedTypes"
                                                    name="checkedTypes"
                                                    value={'type-' + idTermConference}
                                                    checked={this.state.checkedTypes}
                                                    onChange={this.handleChangeCheckbox}
                                                />
                                                <span className="title">Conférences</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <Button onClick={this.toggleFilterDrawer(false)}>Afficher les résultats</Button>
                </Drawer>

            </Fragment>
        );
    }
}

CoursesSearch.propTypes = {
    getCoursesCategories: PropTypes.func.isRequired,
    getCoursesLevels: PropTypes.func.isRequired,
    getCoursesTypes: PropTypes.func.isRequired,
    getCourses: PropTypes.func.isRequired,
    lastLocation: PropTypes.object,
};

const mapStateToProps = (state) => ({
    courses: state.courses,
});

export default withRouter(withLastLocation(connect(mapStateToProps, {getCoursesCategories, getCoursesLevels, getCoursesTypes, getCourses})(CoursesSearch)));



// WEBPACK FOOTER //
// ./src/features/Courses/components/List/CoursesSearch.js